import { useEffect } from 'react'
import { router, usePage } from '@inertiajs/react'
import type { SharedProps } from '@/frontend/types/inertia'

const POLL_INTERVAL_MS = 10_000

// Enquanto algum colaborador digital estiver sendo preparado, recarrega só o
// prop navigableResources em intervalo leve para a sidebar refletir o status
// real (o cache do servidor é invalidado na transição — SZ-1584). Para de
// sondar sozinho quando todos estão ready/failed.
export function useProvisioningPoll() {
  const { props } = usePage<SharedProps>()
  const provisioning = (props.navigableResources?.workers ?? []).some(
    (worker) => worker.provisioning_status !== 'ready' && worker.provisioning_status !== 'failed',
  )

  useEffect(() => {
    if (!provisioning) return undefined

    const intervalId = window.setInterval(() => {
      router.reload({ only: ['navigableResources'] })
    }, POLL_INTERVAL_MS)
    return () => window.clearInterval(intervalId)
  }, [provisioning])
}
